<template>
  <div id="contenedor-usuarios-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            v-on:nuevoUsuario="registrarUsuario"
            v-on:buscar="setBuscarTexto"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :usuarios="getUsuarios">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- CUADRO DE DIALOGO EDITAR -->
    <v-dialog persistent
      v-if="esteUsuario"
      v-model="mostrarVentanaEditarUsuario"
      :width="!$vuetify.breakpoint.xs ? '600' : '90%'">
      <editar-usuario
        :usuarioEditar="esteUsuario"
        v-on:cerrar="cerrarEditarUsuario">
      </editar-usuario>
    </v-dialog>
    <!-- CUADRO DE DIALOGO ELIMINAR -->
    <v-dialog persistent
      v-if="esteUsuario"
      v-model="mostrarVentanaEliminarUsuario"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-usuario
        :usuarioEliminar="esteUsuario"
        v-on:cerrar="cerrarEliminarUsuario">
      </eliminar-usuario>
    </v-dialog>
  </div>
</template>

<script>
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import TituloToolBar from './TituloToolBar.vue';
import EditarUsuario from '@/components/administracion/configuracion/catalogos/usuarios/Editar.vue';
import EliminarUsuario from '@/components/administracion/configuracion/catalogos/usuarios/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'UsuariosDefault',
  components: {
    TituloToolBar,
    EditarUsuario,
    EliminarUsuario,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarUsuario: false,
      mostrarVentanaEditarUsuario: false,
      mostrarVentanaEliminarUsuario: false,
      esteUsuario: null,
      buscarTexto: null,
    };
  },
  apollo: {
    usuarios: {
      query: USUARIOS,
    },
  },
  mounted() {
    eventBus.$on('editar-usuario', (usuario) => {
      this.esteUsuario = usuario;
      this.mostrarVentanaEditarUsuario = true;
    });
    eventBus.$on('eliminar-usuario', (usuario) => {
      this.esteUsuario = usuario;
      this.mostrarVentanaEliminarUsuario = true;
    });
  },
  methods: {
    setBuscarTexto(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
    registrarUsuario() {
      this.mostrarVentanaRegistrarUsuario = true;
    },
    cerrarRegistrarUsuario() {
      this.mostrarVentanaRegistrarUsuario = false;
    },
    cerrarEditarUsuario() {
      this.mostrarVentanaEditarUsuario = false;
      this.esteUsuario = null;
    },
    cerrarEliminarUsuario() {
      this.mostrarVentanaEliminarUsuario = false;
      this.esteUsuario = null;
    },
  },
  computed: {
    getUsuarios() {
      if (!this.usuarios) return [];
      return this.usuarios
        .slice()
        .filter((usuario) => {
          if (!this.buscarTexto) return usuario;
          const expt = new RegExp(this.buscarTexto, 'gi');
          // const nombre = this.$normalizacionTexto(usuario.funcionario.nombre);
          const email = this.$normalizacionTexto(usuario.correoElectronico);
          return (
            // expt.test(nombre)
            expt.test(email)
            // || expt.test(usuario.nombre)
            || expt.test(usuario.correoElectronico)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
